import styled from "styled-components";

export const BoxConfirmActionStyled = styled.div`
  width: 420px;
  padding: 40px 24px 24px;
  background: #ffffff;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;

  .title_text {
    font-size: ${({ theme }) => theme.FONT.SIZE.S22};
    font-family: ${({ theme }) => theme.FONT.STYLE.BOLD};
    color: ${({ theme }) => theme.COLORS.PURPLE_1};
    margin-bottom: 16px;
    text-align: center;
  }

  .sub_text {
    font-size: ${({ theme }) => theme.FONT.SIZE.S16};
    font-family: ${({ theme }) => theme.FONT.STYLE.MEDIUM};
    color: ${({ theme }) => theme.COLORS.GRAY_26};
    text-align: center;
    margin-bottom: 28px;
    white-space: pre-line;
  }

  .action_row {
    display: flex;
    width: 100%;
    gap: 16px;
  }

  .btn_wrap {
    flex: 1;
  }
`;
